import {Alert, Button, TextInput} from "omoplay";
import {useState} from "react";
import BrokenCheckIcon from "../assets/images/icon.check.broken.svg"
import {postFindIdAuthCode, postFindIdGet} from "../api/auth/auth.api";

const FindIdPage = () => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [validAccount, setValidAccount] = useState();
    const [authCode, setAuthCode] = useState();
    const [userAuthCode, setUserAuthCode] = useState("");
    const [validAuthCode, setValidAuthCode] = useState(false);
    const [findId, setFindId] = useState([]);
    // 서버 응답 [{id, isKakao}] 를 아이디 목록(id/pwd)과 카카오 안내로 가른다. 옛 문자열 배열 응답이 와도 깨지지 않게 방어.
    const accounts = Array.isArray(findId) ? findId : [];
    const idAccounts = accounts.filter(account => account && typeof account === "object" && !account.isKakao);
    const hasKakao = accounts.some(account => account && account.isKakao);

    return (
        /* 모바일 레이아웃: `h-screen` + 중앙정렬은 내용이 화면보다 길 때 위쪽이 잘리고 스크롤로도 닿을 수 없다.
           `min-h-[100dvh]`(키보드와 함께 줄어드는 높이) + 카드 `m-auto` 로 교체. 상세 설명은 `JoinPage.js` 주석. */
        <div className="w-full min-h-screen min-h-[100dvh] flex login-background-gradient">
            <div className="flex-1 bg-white flex">
                <div className="m-auto w-full max-w-[458px] px-5 py-8 flex-col items-center gap-4">
                    {
                        validAuthCode ? (
                            <div className="w-full">
                                <div className="w-full flex-col flex-center-all gap-[32px] p-[32px]">
                                    <div className="flex-col flex-center-all gap-2">
                                        <img src={BrokenCheckIcon} alt="broken_check" />
                                        <div className="flex-align-center justify-center text-[24px] font-bold">
                                            아이디 찾기 성공
                                        </div>
                                        <div className="text-tertiary">
                                            {idAccounts.length > 0 ? "고객님의 아이디는 아래와 같습니다." : "입력하신 휴대전화로 가입된 계정입니다."}
                                        </div>
                                    </div>
                                    {/* 응답 = [{id, isKakao}] (`AccountService.FoundAccount`).
                                        id/pwd 계정의 id 만 아이디 박스에 넣는다. 카카오 로그인 계정은 id 가 카카오 숫자 id 라 사용자가
                                        알아볼 수 없고 로그인에도 쓸 수 없으므로, 아이디 목록과 섞지 않고 아래 별도 안내 블록으로 뺀다
                                        (2026-10-16 사용자 피드백: 같은 위계로 섞이면 목록이 깨져 보인다). */}
                                    {
                                        idAccounts.length > 0 && (
                                            <div className="flex-col flex-center-all w-full p-[20px] bg-shape rounded-[8px] gap-1">
                                                {
                                                    idAccounts.map(account => (
                                                        <div key={account.id} className="font-bold text-[20px]">{account.id}</div>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        hasKakao && (
                                            <div className="flex-col w-full p-[16px] rounded-[8px] border border-gray-200 gap-1">
                                                <div className="font-bold text-[15px]">{idAccounts.length > 0 ? "카카오 로그인 계정도 있습니다" : "카카오 로그인 계정이 있습니다"}</div>
                                                <div className="text-tertiary text-sm">
                                                    이 휴대전화로 가입된 카카오 로그인 계정은 별도의 아이디가 없습니다. 로그인 화면에서 <span className="font-bold">카카오 로그인</span>을 이용해 주세요.
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className="w-full">
                                        <Button variants="primary"
                                                size="large"
                                                style={{width: "100%"}}
                                                value="로그인 페이지로 돌아가기"
                                                onClick={() => window.location.href = "/login"}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="flex justify-center text-[24px] font-bold" style={{marginBottom: "20px"}}>
                                    아이디 찾기
                                </div>
                                {
                                    validAccount === false && (
                                        <Alert title="계정 정보를 확인해주세요." type="error" withIcon={true}>
                                            입력한 휴대전화와 연결된 계정이 존재하지 않습니다.
                                        </Alert>
                                    )
                                }
                                <div className="flex-col gap-2 w-full">
                                    <div className="flex-col gap-2">
                                        <label className="block text-gray-700 text-sm font-bold">
                                            휴대전화번호
                                        </label>
                                        <TextInput placeholder="계정과 연결된 휴대전화를 입력해주세요."
                                                   value={phoneNumber}
                                                   onChange={(e) =>
                                                       setPhoneNumber(e.target.value)} />
                                    </div>
                                    {
                                        validAccount && (
                                            <div className="flex-col gap-2">
                                                <label className="block text-gray-700 text-sm font-bold">
                                                    인증번호
                                                </label>
                                                <TextInput placeholder="알림톡으로 받은 인증번호를 입력해 주세요."
                                                           value={userAuthCode}
                                                           onChange={(e) =>
                                                               setUserAuthCode(e.target.value)} />
                                                {
                                                    findId === false && (
                                                        <div className="text-red-500">인증번호가 맞지 않습니다.</div>
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="w-full">
                                    {
                                        authCode?.length > 0 ? (
                                            <Button size="large" variants="primary" value="아이디 찾기"
                                                    style={{width: "100%"}}
                                                    onClick={() => {
                                                        setValidAuthCode(userAuthCode === authCode)

                                                        if (userAuthCode === authCode) {
                                                            postFindIdGet(phoneNumber).then(({data}) => {
                                                                setFindId(data)
                                                            })
                                                        }
                                                    }} />
                                        ) : (
                                            <Button size="large" variants="primary" value="인증번호 받기"
                                                    style={{width: "100%"}}
                                                    onClick={() => {
                                                        postFindIdAuthCode(phoneNumber).then(({data}) => {
                                                            if (data === "Empty") {
                                                                setValidAccount(false)
                                                            } else {
                                                                setValidAccount(true)
                                                                setAuthCode(data)
                                                            }
                                                        })
                                                    }} />
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
            {/* 오른쪽 그라디언트 여백 — 좁은 화면에서는 숨긴다. 종전의 `window.innerWidth` 1회 계산은
                회전·창 크기 변경에 반응하지 않았다. */}
            <div className="hidden sm:flex flex-1 flex-center-all"></div>
        </div>
    );
};
export default FindIdPage;
